function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1676.65,-1466.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1660.59,1556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.133,-28.076C88.769,-28.076 91.26,-29.297 93.945,-32.031L148.779,-86.279C146.436,-88.574 142.139,-89.697 135.986,-89.697L34.619,-89.697C29.199,-89.697 25.342,-88.672 23.193,-86.572L78.272,-32.031C80.957,-29.346 83.496,-28.076 86.133,-28.076ZM17.822,9.375L62.988,-35.156L17.773,-79.688C16.65,-77.783 16.064,-74.561 16.064,-69.971L16.064,-0.342C16.064,4.248 16.65,7.471 17.822,9.375ZM154.248,9.18C155.322,7.275 155.859,4.15 155.859,-0.342L155.859,-69.971C155.859,-74.414 155.322,-77.637 154.248,-79.443L109.229,-35.156L154.248,9.18ZM35.938,19.385L137.305,19.385C142.871,19.385 146.729,18.262 148.926,16.162L103.027,-29.102L98.926,-25C94.727,-20.996 90.625,-19.043 86.133,-19.043C81.641,-19.043 77.539,-20.996 73.34,-25L69.19,-29.102L23.291,16.162C25.732,18.311 29.932,19.385 35.938,19.385Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ba32b5ba.svg";
export { ForwardRef as ReactComponent };